import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { EstruturaRetornoDadosOutputDto } from '../domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { CalendarioPublicacoesOutputDto } from '../domain/DTOs/output/calendario-publicacoes.output.dto';

@Injectable()
export class CalendarioService {

  constructor(private baseService: BaseService) {}

  public ObterCalendariosPublicacoes(
    inputDto: number
  ): Observable<EstruturaRetornoDadosOutputDto<CalendarioPublicacoesOutputDto>> {
    return this.baseService.get(`Calendario/ObterCalendarioPublicacoes?Mes=${inputDto}`);
  }
}
